import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { acceptOrder } from '@/data/api/request/orderDetailsRequest';
import { acceptSellerOrder } from '@/data/api/request/sellerOrderDetailsRequest';
import { DashboardUserType } from '@/utils/enums';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useAcceptOrder() {
  const queryClient = useQueryClient();
  const { session } = useGlobalContext();
  const sessionType = session?.type;

  const acceptOrderFn = (orderId: string) => {
    if (sessionType === DashboardUserType.ADMIN) {
      return acceptOrder(orderId);
    }
    if (sessionType === DashboardUserType.SELLER) {
      return acceptSellerOrder(orderId);
    }
    throw new Error('Invalid session type for acceptOrder');
  };

  const { isPending, error, mutate } = useMutation({
    mutationFn: acceptOrderFn,
    onSuccess: (_data, orderId) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.detailOrder.details, orderId],
      });
      queryClient.invalidateQueries({ queryKey: [cacheKeys.detailOrder.list] });
    },
  });

  const { showSnackError } = useSnackbarContext();

  useEffect(() => {
    if (!error) return;
    showSnackError('Error al aceptar la orden');
  }, [error]);

  return { acceptOrder: mutate, acceptingOrder: isPending };
}
